import React from "react";
import BlogCard from "../BlogCard";
import { blog } from "../../mock/blog";
import { Container, Title, Wrapper, BlogWrapper } from "./style";

const BlogList = () => {
  return (
    <Container main="true">
      <Wrapper>
        <Title title="true">From Our Blog</Title>
        <Title desc="true">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit
        </Title>
      </Wrapper>
      <BlogWrapper>
        {blog.map((value) => {
          return <BlogCard key={value.id} value={value} />;
        })}
      </BlogWrapper>
    </Container>
  );
};
export default BlogList;
